// Returns base URL for API calls.
// Always uses current origin so requests go to the same domain the page was loaded from.
// This prevents issues when REACT_APP_BACKEND_URL (baked at build time) differs from production domain.
export const getBackendUrl = () => {
  if (process.env.NODE_ENV === 'development') {
    const envUrl = process.env.REACT_APP_BACKEND_URL;
    if (envUrl && !envUrl.startsWith('/')) {
      return envUrl.replace(/\/api$/, '');
    }
  }
  return window.location.origin;
};

export const API_BASE_URL = getBackendUrl();
export const API_URL = `${API_BASE_URL}/api`;

// Safe JSON parser — prevents "Unexpected token '<'" crash when server returns HTML
export const safeJson = async (response) => {
  const text = await response.text();
  try {
    return JSON.parse(text);
  } catch {
    // Server returned non-JSON (HTML error page, 502 proxy page, etc.)
    console.error('Non-JSON response:', response.status, text.substring(0, 200));
    throw new Error('Сервер временно недоступен. Попробуйте через несколько секунд.');
  }
};

// Fetch with retry and timeout for resilient API calls
export const fetchWithRetry = async (url, options = {}, { retries = 2, timeout = 30000 } = {}) => {
  let lastError;
  for (let attempt = 0; attempt <= retries; attempt++) {
    try {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), timeout);
      
      const response = await fetch(url, {
        ...options,
        signal: controller.signal,
      });
      clearTimeout(timeoutId);
      return response;
    } catch (error) {
      lastError = error;
      if (error.name === 'AbortError') {
        lastError = new Error('Превышено время ожидания сервера. Попробуйте ещё раз.');
      }
      if (attempt < retries && (error.name === 'AbortError' || error.message === 'Failed to fetch')) {
        await new Promise(r => setTimeout(r, 1000 * (attempt + 1)));
        continue;
      }
      break;
    }
  }
  throw lastError;
};
